import {Dispatch} from "redux"
import {connect} from "react-redux"

// Models
import {RootState} from "../../../models"
import {RecordsStateType} from "../models"

// Selectors
import {selectApproveDialogActive, selectReceiveNext} from "../store/selectors"

// Actions
import * as a from "../store/actions"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    receiveNext: selectReceiveNext(state),
    approveDialogActive: selectApproveDialogActive(state),
    //toggleGraph: selectToggleGraph(state),
});

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    setReceiveNext: (receive: boolean) => dispatch(a.setReceiveNext(receive)),
    setApproveDialogActive: (active: boolean) => dispatch(a.setApproveDialogActive(active)),
   // setToggleGraph: (toggleGraph: boolean) => dispatch(a.setToggleGraph(toggleGraph)),
});

export type WithApproveDialogProps = {
    receiveNext: RecordsStateType["receiveNext"]
    approveDialogActive: RecordsStateType["approveDialogActive"]
    //toggleGraph: RecordsStateType["toggleGraph"]
    setReceiveNext(receive: boolean): void
    setApproveDialogActive(active: boolean): void
    //setToggleGraph(toogleGraph: boolean): void
}

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)
